import { render, staticRenderFns } from "./detailMotor.vue?vue&type=template&id=9f36b2f4&"
import script from "./detailMotor.vue?vue&type=script&lang=ts&"
export * from "./detailMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports